/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebAuthnGetAttestationAllOf
 */
export interface WebAuthnGetAttestationAllOf {
    /**
     * 
     * @type {object}
     * @memberof WebAuthnGetAttestationAllOf
     */
    data?: object;
}

/**
 * Check if a given object implements the WebAuthnGetAttestationAllOf interface.
 */
export function instanceOfWebAuthnGetAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebAuthnGetAttestationAllOfFromJSON(json: any): WebAuthnGetAttestationAllOf {
    return WebAuthnGetAttestationAllOfFromJSONTyped(json, false);
}

export function WebAuthnGetAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnGetAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function WebAuthnGetAttestationAllOfToJSON(value?: WebAuthnGetAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

